import React, { useState } from 'react';
import './AnswerExplainer.css';
import { api } from '../../utils/api';
import { getActiveAiRequestConfig } from '../../utils/aiConfig';

const SIMULATED_DELAY_MS = 700;

export default function AnswerExplainer({ explanation, questionText, choices, selectedIndex, correctIndex }) {
  const [explaining, setExplaining] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [liveExplanation, setLiveExplanation] = useState(null);
  const [error, setError] = useState('');

  const byokConfig = getActiveAiRequestConfig();
  const displayExplanation = liveExplanation || explanation;

  if (!displayExplanation && !byokConfig) return null;

  async function handleExplain() {
    setError('');

    if (byokConfig) {
      setExplaining(true);
      try {
        const result = await api.post('/api/ai/explain-answer', {
          provider: byokConfig.provider,
          apiKey: byokConfig.apiKey,
          questionText,
          choices,
          selectedIndex,
          correctIndex,
        });
        setLiveExplanation(result.explanation);
        setRevealed(true);
      } catch (err) {
        setError(err.message || 'Unable to generate an explanation right now.');
      } finally {
        setExplaining(false);
      }
      return;
    }

    setExplaining(true);
    setTimeout(() => {
      setExplaining(false);
      setRevealed(true);
    }, SIMULATED_DELAY_MS);
  }

  if (revealed) {
    return (
      <div
        className="answer-explainer-panel"
        onCopy={(e) => e.stopPropagation()}
        onCut={(e) => e.stopPropagation()}
        onContextMenu={(e) => e.stopPropagation()}
        onDragStart={(e) => e.stopPropagation()}
      >
        <div className="answer-explainer-panel-header">
          <span>AI explanation</span>
          <button type="button" onClick={() => setRevealed(false)} aria-label="Close explanation">
            &times;
          </button>
        </div>
        <p>{displayExplanation}</p>
      </div>
    );
  }

  return (
    <div className="answer-explainer">
      <button type="button" className="answer-explainer-button" onClick={handleExplain} disabled={explaining}>
        {explaining ? 'Explaining…' : 'Explain with AI'}
      </button>
      {error && <p className="answer-explainer-error">{error}</p>}
    </div>
  );
}
